// extracted by mini-css-extract-plugin
module.exports = {"box":"FJRecordingSet_box__3yyW3","title":"FJRecordingSet_title__7mgff"};